<template>
  <main class="maintenance-page" aria-labelledby="maintenance-title">
    <div
      class="maintenance-page__glow maintenance-page__glow--top"
      aria-hidden="true"
    />
    <div
      class="maintenance-page__glow maintenance-page__glow--bottom"
      aria-hidden="true"
    />

    <section class="maintenance-card">
      <h1 id="maintenance-title">系统维护中</h1>
      <p class="maintenance-card__message">
        系统正在进行维护升级，暂时无法访问。<br />
        给您带来不便，敬请谅解。
      </p>
    </section>
  </main>
</template>

<style scoped>
  .maintenance-page {
    position: relative;
    isolation: isolate;
    display: grid;
    place-items: center;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: hidden;
    padding: 24px;
    color: #f5f5f5;
    background:
      radial-gradient(
        circle at 50% -20%,
        rgba(255, 255, 255, 0.1),
        transparent 42%
      ),
      #080808;
  }

  .maintenance-page::before {
    position: absolute;
    inset: 0;
    z-index: -1;
    background-image:
      linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
    background-size: 56px 56px;
    mask-image: linear-gradient(to bottom, black, transparent 75%);
    content: '';
  }

  .maintenance-page__glow {
    position: absolute;
    z-index: -1;
    width: 360px;
    height: 360px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.07);
    filter: blur(90px);
    pointer-events: none;
  }

  .maintenance-page__glow--top {
    top: -240px;
    right: 8%;
  }

  .maintenance-page__glow--bottom {
    bottom: -280px;
    left: 6%;
    opacity: 0.55;
  }

  .maintenance-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: min(100%, 560px);
    padding: clamp(32px, 7vw, 72px) clamp(24px, 7vw, 64px);
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 24px;
    background: rgba(20, 20, 20, 0.72);
    box-shadow:
      0 24px 80px rgba(0, 0, 0, 0.32),
      inset 0 1px rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(16px);
  }

  .maintenance-icon {
    display: grid;
    place-items: center;
    width: 76px;
    height: 76px;
    margin-bottom: 28px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.08);
  }

  .maintenance-icon svg {
    width: 42px;
    height: 42px;
  }

  .maintenance-card__eyebrow {
    margin: 0 0 12px;
    color: rgba(255, 255, 255, 0.48);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2em;
  }

  h1 {
    margin: 0;
    color: #fff;
    font-size: clamp(30px, 6vw, 44px);
    font-weight: 600;
    letter-spacing: 0.08em;
  }

  .maintenance-card__message {
    margin: 20px 0 0;
    color: rgba(255, 255, 255, 0.64);
    font-size: 15px;
    line-height: 1.9;
  }

  .maintenance-card__status {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 32px;
    padding: 8px 14px;
    color: rgba(255, 255, 255, 0.48);
    font-size: 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.06);
  }

  .maintenance-card__status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #bcbcbc;
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
  }

  @media (max-width: 480px) {
    .maintenance-page {
      padding: 16px;
    }

    .maintenance-card {
      border-radius: 20px;
    }

    .maintenance-card__message {
      font-size: 14px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .maintenance-page__glow {
      filter: blur(60px);
    }
  }
</style>
